import {abstractFilter} from './../abstractFilter';
import U from './../../lib-utils';
function F() {
    return (F.is(this) ? this.init : F.F).apply(this, Array.prototype.slice.call(arguments));
}

var P = F.leu_extend(abstractFilter).prototype;

const rxlist = [
    {
        rx: /^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:(?:\s|T)(\d{1,2})(?::(\d{1,2})(?::(\d{1,2})){0,1}){0,1}){0,1}/i,
        y: 3, m: 2, d: 1, h: 4, mi: 5, s: 6, r: /[,\-\\/]/g, t: '.'
    },
    {
        rx: /^(\d{4})-(\d{1,2})-(\d{1,2})(?:(?:\s|T)(\d{1,2})(?::(\d{1,2})(?::(\d{1,2})){0,1}){0,1}){0,1}/i,
        y: 1, m: 2, d: 3, h: 4, mi: 5, s: 6, r: null, t: null
    }
];

P.apply_filter = function (current_value, params, field_name) {
    if (U.is_object(current_value) && (current_value instanceof Date)) {
        return current_value;
    }
    if ((typeof current_value) === 'string') {
        for (let i = 0; i < rxlist.length; i++) {
            let innerValue = current_value;
            if (rxlist[i].r) {
                innerValue = current_value.replace(rxlist[i].r, rxlist[i].t);
            }
            let rx = rxlist[i].rx.exec(innerValue);
            if (rx) {
                let Y = U.IntMoreOr(rx[rxlist[i].y], 0, null);
                if (null !== Y) {
                    let mon = U.IntMoreOr(rx[rxlist[i].m], -1, null);
                    if (null !== mon) {
                        let month = U.IntMoreOr(mon - 1, -1, null);
                        if (null !== month) {
                            let d = U.IntMoreOr(rx[rxlist[i].d], 0, null);
                            if (null !== d) {
                                let H = U.IntMoreOr(rx[rxlist[i].h], 0, 0);
                                let mi = U.IntMoreOr(rx[rxlist[i].mi], 0, 0);
                                let s = U.IntMoreOr(rx[rxlist[i].s], 0, 0);
                                let rd = new Date();
                                rd.setFullYear(Y, month, d);
                                rd.setHours(H, mi, s, 0);
                                return rd;
                            }
                        }
                    }
                }
            }
        }

        this.create_invalid_value(field_name, 'bad format (d.m.Y|xml|sql format required)');
    }
    return this.create_invalid_value(field_name, 'not a Date / known Date[Time] format');
};

export default F;


